import React from 'react';
import { Svg } from '@chat/components';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setDifyLogWorkflowRunId } from '@/redux/index/action';
import { IM_CTX, IM_MESSAGE } from '@/typings/global';

interface MsgActionsProps {
    item: IM_MESSAGE;
}

const getWorkflowRunId = (item: IM_MESSAGE): string => (item.ctx as IM_CTX)?.workflow_run_id || '';

function MsgActions({ item }: MsgActionsProps): JSX.Element | null {
    const dispatch = useDispatch();
    const { isFaqStage, workflowLogEnabled, isMobile } = useSelector(
        ({ IMReducer, FaqReducer, IndexReducer }) => ({
            isFaqStage: IMReducer.stage === 0,
            workflowLogEnabled: FaqReducer.workflow_log === 1,
            isMobile: IndexReducer.Device.isMobile
        }),
        shallowEqual
    );
    const workflowRunId = getWorkflowRunId(item);
    // 与 commonlibs/browserTip.js 保持一致，IE 不展示 Dify 工作流日志入口。
    const isIE = /MSIE |Trident\//.test(window.navigator.userAgent);

    if (!isFaqStage || !workflowLogEnabled || isMobile || isIE || !workflowRunId) {
        return null;
    }

    return (
        <div className="im-message-actions">
            <button
                type="button"
                className="im-dify-log-action"
                aria-label="查看工作流日志"
                title="查看工作流日志"
                onClick={() => dispatch(setDifyLogWorkflowRunId(workflowRunId))}
            >
                <Svg.DocumentSearch className="im-dify-log-icon" />
            </button>
        </div>
    );
}

export default MsgActions;
